import MitgliederList from "./MitgliederList/MitgliederList.vue";
import Team from "./Team/Team.vue";

export default {
  MitgliederList,
  Team,
};
